module.exports = __webpack_public_path__ + "img/1.8c1e13d1.webp";